import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCInputModule } from '@wlp/ui-c-input';
import { UiCHeaderOnboardingModule } from '@wlp/ui-c-header-onboarding';

let UiCComercialAgentV2Component = class UiCComercialAgentV2Component {
    constructor() {
        this.isBack = true;
        this.back = new EventEmitter();
        this.continue = new EventEmitter();
    }
    goBack() {
        this.back.emit();
    }
    goContinue() {
        if (this.form.valid) {
            this.continue.emit();
        }
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCComercialAgentV2Component.prototype, "isBack", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCComercialAgentV2Component.prototype, "form", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCComercialAgentV2Component.prototype, "errorMessages", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCComercialAgentV2Component.prototype, "block", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCComercialAgentV2Component.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCComercialAgentV2Component.prototype, "description", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCComercialAgentV2Component.prototype, "primaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCComercialAgentV2Component.prototype, "secondaryColor", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCComercialAgentV2Component.prototype, "back", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCComercialAgentV2Component.prototype, "continue", void 0);
UiCComercialAgentV2Component = __decorate([
    Component({
        selector: 'ui-c-comercial-agent-v2',
        template: "<div class=\"animation-type\">\n  <ui-c-header-onboarding\n    [isBack]=\"isBack\" [textBack]=\"'ONBORDING.V2.BUTTON.BACK' | wlpTranslate\"\n    [title]=\"title\" [description]=\"description\"\n    [primaryColor]=\"primaryColor\" [secondaryColor]=\"secondaryColor\"\n    (back)=\"goBack()\"\n  >\n  </ui-c-header-onboarding>\n\n  <form [formGroup]=\"form\">\n    <ion-row class=\"ion-justify-content-left ion-align-items-center\">\n      <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n        <ui-c-input\n          [form]=\"form\"\n          [errorMessages]=\"errorMessages\"\n          [formName]=\"'nameAgent'\"\n          [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.AGENT' | wlpTranslate\"\n          [name]=\"'ONBORDING.V2.FORM.LABEL.AGENT' | wlpTranslate\"\n        >\n        </ui-c-input>\n      </ion-col>\n\n      <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n        <ui-c-input\n          [form]=\"form\"\n          [errorMessages]=\"errorMessages\"\n          [formName]=\"'cpfAgent'\"\n          [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.CPF' | wlpTranslate\"\n          [name]=\"'ONBORDING.V2.FORM.LABEL.CPF' | wlpTranslate\"\n          [isCPF]=\"true\"\n        >\n        </ui-c-input>\n      </ion-col>\n    </ion-row>\n  </form>\n\n  <ion-row class=\"ion-justify-content-left ion-margin-top ion-margin-bottom\">\n    <ion-col [size]=\"12\" [sizeMd]=\"4\" [sizeSm]=\"4\">\n      <ui-c-button expand=\"block\" (continue)=\"goContinue()\" [disabled]=\"form.invalid\">\n        {{ 'ONBORDING.V2.BUTTON.NEXT' | wlpTranslate }}\n      </ui-c-button>\n    </ion-col>\n  </ion-row>\n</div>\n"
    })
], UiCComercialAgentV2Component);

let UiCComercialAgentV2Module = class UiCComercialAgentV2Module {
};
UiCComercialAgentV2Module = __decorate([
    NgModule({
        declarations: [UiCComercialAgentV2Component],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            NgxMaskIonicModule,
            IonicModule,
            UiBsTranslateModule,
            FormsModule,
            UiCButtonModule,
            UiCInputModule,
            UiCHeaderOnboardingModule,
        ],
        exports: [UiCComercialAgentV2Component]
    })
], UiCComercialAgentV2Module);

export { UiCComercialAgentV2Component, UiCComercialAgentV2Module };
//# sourceMappingURL=wlp-ui-c-comercial-agent-v2.js.map
